import React from "react";
import { Button, Checkbox } from "antd";

interface SingleSelectButtonGroupProps {
  label: string;
  options: string[];
  selected: string;
  setSelected: (selected: string) => void;
  checked: boolean;
  setChecked: (checked: boolean) => void;
  showCheckBox?: boolean;
  checkboxClassName?: string;
}

const SingleSelectButtonGroup: React.FC<SingleSelectButtonGroupProps> = ({
  label,
  options = [],
  selected,
  setSelected,
  checked,
  setChecked,
  showCheckBox = true,
  checkboxClassName,
}) => {
  return (
    <div className="col-span-1">
      {showCheckBox ? (
        <Checkbox
          checked={checked}
          onChange={(e) => {
            setChecked(e.target.checked)
            if (!e.target.checked) {
              setSelected("")
            }
          }}
          className="common-bold-label"
        >
          {label}
        </Checkbox>
      ) : (
        <p className="common-bold-label">{label}</p>
      )}

      {checked && (
        <div
          className={`flex flex-wrap gap-x-2 gap-y-2 mt-[24px] ${checkboxClassName}`}
        >
          {options.map((option) => (
            <Button
              type="text"
              key={option}
              onClick={() => setSelected(option)}
              className={`cursor-pointer rounded-[30px] px-5 py-1 text-sm font-normal font-['Inter'] leading-tight transition flex items-center gap-2 ${selected === option ? "text-[#1849a9]" : "text-[#1d2939]"
                }`}
              style={{
                border: `1px solid ${selected === option ? "#53b1fd" : "#e4e7ec"
                  }`,
                backgroundColor: `${selected === option ? "#d1e9ff" : ""}`,
              }}
            >
              {selected === option && (
                <span className="h-2 w-2 bg-[#1849a9] rounded-full" />
              )}
              {option}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SingleSelectButtonGroup;
